import type { CollapseProps } from "antd";

import BannerMobileInfo from "./Info";
import BannerDetail from "./BannerMobileDetail";
import BannerMobileFiles from "./BannerMobileFiles";


export const BannerDetailConstants = {
	EN: "Banner Detayları - İngilizce",
	TR: "Banner Detayları"
};

export const BannerConstants = {
	INFO: "Banner Özellikleri",
	BANNER_LOCALIZABLE: BannerDetailConstants,
	BANNER_FILES: "Banner Resimleri",
};

export const BannerMobileItems: CollapseProps["items"] = [
	{
		key: "1",
		label: BannerConstants.INFO,
		children: <BannerMobileInfo />,
	},
	{
		key: "2",
		label: BannerConstants.BANNER_FILES,
		children: <BannerMobileFiles />,
	},
	{
		key: "3",
		label: BannerConstants.BANNER_LOCALIZABLE.TR,
		children: <BannerDetail Culture="tr-TR" />,
	},
	{
		key: "4",
		label: BannerConstants.BANNER_LOCALIZABLE.EN,
		children: <BannerDetail Culture="en-US" />,
	},
];
